import { useFormik } from "formik";
import { useNavigate } from "infrastructure/router";
import { useSettings } from "hooks";
import { WebRoutes } from "consts/enpoints/web";
import type { MerchantSettings } from "features/merchants/types";
import ShoppingPlatforms from "features/ecommerce/ShoppingPlatforms";
import { Merchant } from "ui/forms/ECommerce";

const usePlatforms = () => {
    const { getSettings } = useSettings<MerchantSettings>();
    const navigate = useNavigate();

    return useFormik({
        initialValues: {
            [Merchant.BusinessInformation.FormField.Platforms]: ShoppingPlatforms.make(getSettings().platforms)
                .parse()
                .toKeys()
        },
        onSubmit: values => navigate(`${WebRoutes.ECommerce.Platforms}/${values[
            Merchant.BusinessInformation.FormField.Platforms
        ][0]}`)
    });
};

export default usePlatforms;
